<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row style="margin-bottom: 1rem;">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('textGroupList') }}</h1>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end" style="display: flex; align-items: center;">
              <div class="custom-search-input-wrapper-1 mr-3">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="textgroup-field-search-groupreplacetext" type="text" :placeholder="$t('textGroupName')"
                    :aria-label="$t('textGroupName')"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn id="button-add-groupreplacetext" color="primary" class="control-btn create-btn customadd"
                variant="flat" size="large" prepend-icon="mdi-plus" rounded="xl" @click="Add()">
                {{ $t("add") }}
                <v-tooltip activator="parent" location="top">{{ $t('_addNewTextGroup') }}</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
          
          
          <v-data-table-server
            v-model:options="options" 
            :items-per-page="options.itemsPerPage"
            :items-length="searchTotalTable" 
            :items="menus" 
            :headers="headers" 
            :loading="loading" 
            >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td>{{ item.name }}</td>
                <td style="text-align: center">
                  {{ substring(item.countReplaceText) }}
                </td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit -->
                    <v-btn id="button-edit-groupreplacement" variant="text" density="comfortable" @click="Edit(item)"
                      class="action-btn edit-btn" icon>
                      <v-img :src="images.editBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('edit') }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Delete -->
                    <v-btn id="button-delete-groupreplacement" variant="text" density="comfortable"
                      @click="DeleteGroup(item.groupReplaceID)" class="action-btn delete-btn" icon>
                      <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                      <v-tooltip activator="parent" location="top">
                        {{ $t('delete') }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
            <!-- Custom footer -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="Editdialog" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t('edit') }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field id="groupname-field-popupedit-groupreplacetext" :label="$t('groupModelName')" v-model="GroupModel.Name"
                :rules="[rules.required]" required outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete :label="$t('model')" v-model="GroupModel.Model" :items="DDGPTModel" item-text="name"
                item-value="modelDisplayID" chips clearable deletable-chips multiple outlined></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Editdialog = false">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="Save()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add -->
    <v-dialog v-model="Adddialog" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" style="position: sticky; top: 0px">
          {{ $t('add') }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field id="groupname-field-popupadd-groupreplacetext" :label="$t('groupModelName')" v-model="GroupModel.Name"
                :rules="[rules.required]" required outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete :label="$t('model')" v-model="GroupModel.Model" :items="DDGPTModel" item-text="name"
                item-value="modelDisplayID" chips clearable deletable-chips multiple outlined></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Adddialog = false">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="Save()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('deleteTextGroup') }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            {{ $t('_confirmDeleteTextGroup') }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- loading -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
export default {
  name: 'GroupReplacetext',
  mixins: [checkPermissionTwo],
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    today: null,

    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    rules: {
      required: (value) => !!value || 'Required.',
    },
    DDGPTModel: [],
    headers_version_history: [],

    searchName: '',
    isSearch: false,
    isFirst: true,
    menus: [],
    GroupModel: {
      GroupID: null,
      Name: null,
      Model: null,
      NameModel: null,
    },
    sortBy: [],
    sortDesc :[],
    images: {
      deleteBtn: deleteBtn,
      editBtn: editBtn,
      deleteIcon: deleteIcon,
    },
    dialog_delete: false,
    deleteItem: null,
  }),
  computed: {
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, width: '95px' },
        { title: this.$t('textGroupName'), align: 'left', sortable: true ,value:'Name'},
        { title: this.$t('totalNumber'), align: 'center', sortable: true ,value:'Count'},
        { title: this.$t('manage'), align: 'center', sortable: false, width: '220px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Search() {
      this.dialog = true;
      this.isSearch = true;
      this.options.page = 1;
      this.GetDefault();
    },
    Get() {
      this.loading = true;
      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchName,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      this.$call.GetTableGroupReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.menus = dataResponse.data.data;
            this.totalTable = this.isFirst ? dataResponse.data.total : this.totalTable;
          } else {
            this.menus = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loading = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      this.dialog = true;
      this.loading = true;
      const { itemsPerPage } = this.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchName,
        sortDesc: null,
        sortBy: null
      };
      this.$call.GetTableGroupReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.menus = dataResponse.data.data;
            this.totalTable = this.isFirst ? dataResponse.data.total : this.totalTable;
          } else {
            this.menus = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loading = false;
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      this.deleteItem = id;
      this.dialog_delete = true;

    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem;
      try {
        this.dialog_delete = false;
            this.dialog = true;
            this.$call.DeleteGroupReplaceText(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  this.dialog = false;
                  this.$swal.fire({
                    title: this.$t('_textGroupDeletedSuccess'),
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'top',
                    customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                  });
                  this.Get();
                }
                this.dialog = false;
              },
              (errorResource) => {
                this.dialog = false;
                console.error(errorResource);
              }
            );
          }
        catch (error) {
        this.LogTrace(error, "DeleteTextGroup");
      }
    },
    Add() {
      this.$router.push({
        name: 'ReplaceText',
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      this.$router.push({
        name: 'ReplaceText',
        query: {
          id: item.groupReplaceID,
          name: item.name,
        },
      });
    },
    substring(text) {
      if (text.length > 50) {
        return text.substring(0, 50) + '...';
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.custom-search-input-wrapper-1 {
  width: 100%;
  max-width: 300px;
}
</style>
